import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Icon from './Icon';
export default function ErrorMessage(props) {
    const { title, children, overlay } = props;
    return (_jsxs(StyledErrorMessage, { className: `ErrorMessage ${props.className ?? ''} ${overlay ? 'overlay' : ''}`, children: [_jsx(StyledIcon, { name: "error" }), _jsx(StyledHeading, { children: title ?? 'Oh dear...' }), children] }));
}
const StyledErrorMessage = styled.div `
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding: 0 10%;

	&.overlay {
		position: absolute;
	}
`;
const StyledIcon = styled(Icon) `
	font-size: 3rem;
	color: ${(props) => props.theme.palette.error};
`;
const StyledHeading = styled.h4 `
	margin: ${(props) => props.theme.spacing.md} 0;
	font-size: ${(props) => props.theme.typography.xl};
`;
//# sourceMappingURL=ErrorMessage.js.map